import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["confirmed","packed","shipped","out_for_delivery","delivered","cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");

  const load = (status) => api.get("/admin/orders", { params: status ? { status } : {} }).then((r) => setOrders(r.data.orders));
  useEffect(() => { load(filter); }, [filter]);

  const updateStatus = async (id, status) => {
    try {
      await api.post(`/admin/orders/${id}/status`, { status });
      toast.success("Status updated");
      load(filter);
    } catch (e) {
      toast.error("Failed");
    }
  };

  return (
    <div className="p-8" data-testid="admin-orders-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-xs text-[#FF3B30] tracking-widest">FULFILLMENT</div>
          <h1 className="font-display text-5xl tracking-tighter mt-2">ORDERS</h1>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="bg-white border border-black/20 px-4 py-2 font-display tracking-widest text-xs" data-testid="admin-orders-filter">
          <option value="">ALL STATUSES</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s.toUpperCase()}</option>)}
        </select>
      </div>

      <div className="border border-black/10 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="font-display tracking-widest text-xs text-black/50">
            <tr className="border-b border-black/10">
              <th className="text-left p-3">ORDER #</th>
              <th className="text-left p-3">CUSTOMER</th>
              <th className="text-left p-3">ITEMS</th>
              <th className="text-right p-3">TOTAL</th>
              <th className="text-left p-3">DATE</th>
              <th className="text-left p-3">STATUS</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-black/5" data-testid={`admin-order-${o.id}`}>
                <td className="p-3 font-mono text-xs">{o.order_no}</td>
                <td className="p-3">{o.user_email}</td>
                <td className="p-3">{o.items.length}</td>
                <td className="p-3 text-right font-display">{formatINR(o.pricing.total)}</td>
                <td className="p-3 text-black/60 text-xs font-mono">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="p-3">
                  <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="bg-white border border-black/20 px-2 py-1 text-xs font-display tracking-widest">
                    {STATUSES.map((s) => <option key={s} value={s}>{s.toUpperCase()}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {!orders.length && <tr><td colSpan="6" className="p-12 text-center text-black/40 font-mono text-xs">NO ORDERS</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
